module.exports = __webpack_public_path__ + "img/add_btn_icon490.01e66370.svg";